// extracted by mini-css-extract-plugin
export default {"courseInfo":"ExerciseStatistics_courseInfo__G+td9"};